/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="95.57"
        height="78.95"
        viewBox="0 0 95.57 78.95"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#ffb81c"
          d="M47.79 17.4a8.37 8.37 0 1 0 8.36 8.37 8.36 8.36 0 0 0-8.36-8.37Zm0 2.5a5.87 5.87 0 1 1-5.86 5.87 5.86 5.86 0 0 1 5.86-5.87Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#ffb81c"
          d="M53.5 62.56a3.21 3.21 0 1 0-3.21 3.21 3.21 3.21 0 0 0 3.21-3.21"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
        <path
          fill="#0e497b"
          d="M81.5 3a1.25 1.25 0 0 1 1.24 1.13V77.7a1.24 1.24 0 0 1-1.12 1.24H14.11a1.24 1.24 0 0 1-1.24-1.12V24.76a1.25 1.25 0 0 1 2.49-.13v51.82h64.88v-71H69.83v9.82a1.26 1.26 0 0 1-1.12 1.25h-.13a1.25 1.25 0 0 1-1.24-1.12V4.2A1.26 1.26 0 0 1 68.5 3h13Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M47.08.22a1.23 1.23 0 0 1 1.29-.07l.12.07 46.54 31.87a1.24 1.24 0 0 1 .33 1.73 1.26 1.26 0 0 1-1.63.4l-.11-.07L47.79 2.76 1.96 34.15a1.26 1.26 0 0 1-1.66-.22l-.08-.11a1.24 1.24 0 0 1 .22-1.65l.1-.08ZM35.5 59.1c0-17 24-17.16 24.51-.51v19H57.5V59.1c0-13.69-19.13-13.82-19.51-.41v18.94H35.5Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'HouseIcon';

export default Icon;
